<div class="photoeditor-tools">
  <ul>
    <!-- Zoom In -->
    <li (click)="onListItemClick('zoomIn')" [ngClass]="{ 'is-active': selectedAction === 'zoom-in' }">
      <span class="material-icons-outlined ns-button--menu">zoom_in</span>
    </li>

    <!-- Zoom Out -->
    <li (click)="onListItemClick('zoomOut')" [ngClass]="{ 'is-active': selectedAction === 'zoom-out' }">
      <span class="material-icons-outlined ns-button--menu">zoom_out</span>
    </li>

    <!-- Numbering -->
    <li (click)="onListItemClick('numbering')" [ngClass]="{ 'is-active': selectedAction === 'numbering' }">
      <span class="material-icons-outlined ns-button--menu">insert_comment</span>
      <span class="photoeditor-tools__numbering">{{ numberingIndex + 1 }}</span>
    </li>

    <!-- Freehand -->
    <li (click)="onListItemClick('freeHand')" [ngClass]="{ 'is-active': selectedAction === 'freeHand' }">
      <span class="material-icons-outlined ns-button--menu">edit</span>
    </li>

    <!-- Shape -->
    <li
      (click)="onListItemClick('shape')"
      [ngClass]="{ 'is-active': ['shape', 'rectangle', 'circle'].indexOf(selectedAction) !== -1 }"
    >
      <span class="material-icons-outlined ns-button--menu">{{ activeShapeIcon }}</span>
      <div class="photoeditor-tools__submenu" *ngIf="isShapeSubmenuActive">
        <ul>
          <li (click)="selectShape($event, 'rectangleShape')">
            <span class="material-icons-outlined ns-button--menu">crop_din</span>
          </li>
          <!-- <li (click)="selectShape($event, 'circleShape')">
            <span class="material-icons-outlined ns-button--menu">circle</span>
          </li> -->
          <li (click)="selectShape($event, 'ellipseShape')">
            <span class="material-icons-outlined ns-button--menu">circle</span>
          </li>
          <!-- <li (click)="clearShape()">
              <span class="material-icons-outlined ns-button--menu">clear</span>
            </li> -->
        </ul>
      </div>
    </li>

    <!-- SVG elements -->
    <li (click)="onListItemClick('svgElement')" [ngClass]="{ activeLi: selectedAction === 'svgElement' }">
      <span class="material-icons-outlined ns-button--menu">label</span>
      <div class="photoeditor-tools__submenu" *ngIf="isSvgElementMenuActive">
        <ul>
          <li (click)="selectSvgElement($event, element.value)" *ngFor="let element of svgElements | keyvalue">
            <span class="material-icons-outlined ns-button--menu">{{ element.key }}</span>
          </li>
        </ul>
      </div>
    </li>

    <!-- Stroke -->
    <li (click)="onListItemClick('stroke')" [ngClass]="{ 'is-active': selectedAction === 'stroke' }">
      <span class="material-icons-outlined ns-button--menu">horizontal_split</span>
      <div class="photoeditor-tools__submenu" *ngIf="isStrokeSubmenuActive">
        <ul>
          <li (click)="selectStroke(stroke)" *ngFor="let stroke of availableStrokes; let i = index">
            <div
              class="ns-button--menu tool-line"
              [ngClass]="{ 'is-selected': strokeWidth === stroke }"
              [style.height]="2.5 * (i + 1) + 'px'"
            ></div>
          </li>
        </ul>
      </div>
    </li>

    <!-- Color -->
    <li (click)="onListItemClick('color')" [ngClass]="{ 'is-active': selectedAction === 'color' }">
      <span
        class="material-icons ns-button--menu"
        [style.color]="selectedColor"
        style="-webkit-text-stroke: 2px rgb(255, 255, 255)"
        >circle</span
      >
      <div class="photoeditor-tools__submenu" *ngIf="isColorSubmenuActive">
        <ul>
          <ng-container *ngFor="let color of availableColors">
            <li *ngIf="color !== selectedColor" (click)="selectColor(color)">
              <span class="material-icons ns-button--menu" [style.color]="color" *ngIf="color !== selectedColor"
                >circle</span
              >
            </li>
          </ng-container>
        </ul>
      </div>
    </li>

    <!-- Description -->
    <li
      *ngIf="selectedNumberingElement"
      (click)="onListItemClick('description')"
      id="trigger"
      [ngClass]="{ 'is-active': selectedAction === 'description' || !isModalVisible }"
    >
      <span class="material-icons-outlined ns-button--menu">edit_note</span>
    </li>
    <!-- Clear selection -->
    <li (click)="onListItemClick('deleteShape')" *ngIf="selectedElement">
      <span class="material-icons-outlined ns-button--menu" style="color: red">delete</span>
    </li>
  </ul>
</div>
